import { BuilderConfig, FontAwesomeIconKey } from './builderConfigs'
import { useSelector } from '../..'
import { Spin, Alert } from 'antd'

const MAX_TITLE_LENGTH = 100
const MAX_DESC_LENGTH = 500

const icon: FontAwesomeIconKey = 'fa-code'

export const HtmlBuilderConfig: BuilderConfig<'html'> = {
  key: 'html',
  builderHomeData: {
    type: 'html',
    description: (
      <p>
        Upload a ZIP archive containing HTML content (interactive experiences,
        maps, training modules) for viewing on web and mobile.
      </p>
    ),
    enabled: true,
    icon: 'code',
    route: '/builders/html',
    title: 'HTML',
  },
  previewLabels: {
    title: 'HTML',
    description:
      'An HTML asset is a custom interactive experience packaged as a ZIP ' +
      'archive containing HTML, CSS, JavaScript, and media files.',
  },
  crumbTrail: {
    linkTo: '/builders/home',
    crumbText: 'HTML',
    crumbIcon: `fa ${icon}`,
  },
  fieldValidators: {
    title: {
      validateTrigger: 'onBlur',
      rules: [
        { required: true, message: 'Title is required' },
        {
          max: MAX_TITLE_LENGTH,
          message: `Title has a maximum character limit of ${MAX_TITLE_LENGTH}`,
        },
      ],
    },
    description: {
      validateTrigger: 'onBlur',
      rules: [
        {
          max: MAX_DESC_LENGTH,
          message: `Description has a maximum character limit of ${MAX_DESC_LENGTH}`,
        },
      ],
    },
  },
  formLabels: {},
  icon,
  screenHandlers: {
    createScreen: {
      next: (saveToDb) => saveToDb(),
    },
    metaScreen: {
      next: (saveToDb) => saveToDb(),
    },
  },
  assetSerializer: (data) => {
    const { builderData, user } = data
    const assetMetaData = {
      id: builderData.id,
      asset_type: HtmlBuilderConfig.key,
      owner: user.id,
      title: builderData.title,
      description: builderData.description,
      tags: builderData.tags,
      filename: builderData.zipFileName,
      icon,
      color: '#e34c26',
      preview: null,
    }
    const assetData = {
      zipKey: builderData.zipKey,
      zipFileName: builderData.zipFileName,
      image: builderData.leadImage,
    }
    return {
      assetMetaData,
      assetData,
      ContentType: 'application/json',
      assetDataSerialized: JSON.stringify(assetData),
    }
  },
  Content: () => {
    const htmlState = useSelector((state: any) => state.builders.html)

    if (htmlState.zipUploading) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <Spin tip="Uploading and validating ZIP..." />
        </div>
      )
    }

    if (htmlState.zipValid && htmlState.zipKey) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            gap: 16,
          }}
        >
          <i
            className="fa fa-check-circle"
            style={{ fontSize: 48, color: '#52c41a' }}
          />
          <p>
            <strong>{htmlState.zipFileName}</strong> uploaded and validated
          </p>
        </div>
      )
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          gap: 16,
        }}
      >
        {htmlState.zipError && (
          <Alert message={htmlState.zipError} type="error" showIcon />
        )}
        <p>
          Upload a ZIP archive containing an <code>index.html</code> file using
          the form on the right.
        </p>
      </div>
    )
  },
}
